import React from "react";
import { Link } from 'react-router-dom';

import { WEBMAIL_URL } from './SiteHeader';
import './SiteChrome.css';

// Public site footer (home, login, sign up, password pages)
const SiteFooter = () => (
	<footer className="dm-site dm-footer">
		<div className="dm-container dm-footer-inner">
			<span>&copy; {new Date().getFullYear()} Diamta. All rights reserved.</span>
			<nav aria-label="Footer" className="dm-footer-links">
				<Link to="/privacy">Privacy policy</Link>
				<Link to="/contact">Contact us</Link>
				<Link to="/login">Log in</Link>
				<a href={WEBMAIL_URL}>Webmail</a>
			</nav>
		</div>
	</footer>
);

export default SiteFooter;
